<div class="demo-account" *ngIf="isDemoAccount">
  <span>{{ "you_are_viewing_the_gtmhub_demo_account" | localize }}</span>
</div>
